import React from 'react';
import { CinematicScene } from '../CinematicScene';
import { Reveal } from '../Reveal';
import { ActionButton } from '../ActionButton';
import { imagery } from '../../data/site';
import { MotionMode } from '../../types/motion';
interface CoffeeSceneProps {
  motionMode?: MotionMode;
}
export function CoffeeScene({
  motionMode = 'cinematic'
}: CoffeeSceneProps) {
  return <CinematicScene id="coffee" image={imagery.coffee} imageAlt="Hand-roasted beans poured from a brass scoop through a shaft of warm light" motionMode={motionMode} scrim="right" data-id="element-39" data-mp="10ujdgegya3qp">
      <div className="flex h-full w-full items-center justify-end" data-id="element-40" data-mp="ru4mozl7vwft">
        <div className="max-w-xl px-6 text-left md:px-16 md:text-right lg:px-24" data-id="element-41" data-mp="rrs18cg933y0">
          <Reveal data-id="element-42" data-mp="vvpysipxg6oy">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-brass" data-id="element-43" data-mp="vt3quhz4jp67">
              The Coffee Logic
            </p>
          </Reveal>

          <Reveal delay={0.12} data-id="element-44" data-mp="mtgpfw6eajd5">
            <h2 className="font-display text-[2.1rem] font-normal leading-[1.15] text-cream md:text-5xl" data-id="element-45" data-mp="mwup2wnocegw">
              BEYOND THE CUP.
            </h2>
          </Reveal>

          <Reveal delay={0.24} data-id="element-46" data-mp="2wwdxii6ypk02">
            <p className="mt-7 max-w-md font-mono text-[12px] leading-[1.95] text-stone md:ml-auto md:text-[12.5px]" data-id="element-47" data-mp="2wz8ge5abuwrd">
              Every bean tells a story of ethical partnership and roasting
              mastery. By partnering with local roasters, we ensure that every
              pour is a tribute to the farmers and the craft. Taste the
              difference that intention makes.
            </p>
          </Reveal>

          <Reveal delay={0.36} data-id="element-48" data-mp="2rycetydg7mp4">
            <div className="mt-9" data-id="element-49" data-mp="2rykrpq9kms0b">
              <ActionButton href="#visit" variant="ghost" data-id="element-50" data-mp="2rznje0epwyha">
                Shop Our Blends
              </ActionButton>
            </div>
          </Reveal>
        </div>
      </div>
    </CinematicScene>;
}